<template>
	<div class="join-entry-page">
		<div class="bg-wrap">
			<img class="bg-img" src="http://pic5.40017.cn/i/ori/1ODAMPKO1cA.png" alt="招聘首页背景" />
		</div>

		<section class="entry-intro">
			<!-- <h3>携手筑梦 · 共创未来</h3> -->
			<p>JOIN YILONG HOTEL TECHNOLOGY</p>
			<div class="intro-subtitle">加入我们</div>
		</section>

		<section class="entry-list">
			<button class="entry-btn campus" type="button" @click="goCampusRecruit">
				校园招聘
			</button>
			<button class="entry-btn social" type="button" @click="goSocialRecruit">
				社会招聘
			</button>
		</section>
	</div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { CHANNEL, RECOMMEND_Id } from "@/utils/constants";
import { getSessionStorage } from "@/utils/storage";

const router = useRouter();

const getBaseQuery = (entryType, recruitType) => ({
	channel: getSessionStorage(CHANNEL) || "official",
	recommendId: getSessionStorage(RECOMMEND_Id) || "",
	entryType,
	recruitType,
});

const goCampusRecruit = () => {
	router.push({
		path: "/joinUs/campusHire",
		query: getBaseQuery("campus", "campusGraduate"),
	});
};

const goSocialRecruit = () => {
	router.push({
		path: "/joinUs/jobList",
		query: getBaseQuery("social", "social"),
	});
};
</script>

<style lang="scss" scoped>
.join-entry-page {
	// min-height: calc(100vh - 180rem);
	// padding: 0 32rem;
	// box-sizing: border-box;
	// background: url("http://pic5.40017.cn/i/ori/1NNQrzJrFoQ.png") no-repeat center top;
	// background-size: cover;
	position: relative;
	min-height: calc(100vh - 180rem);
	padding: 0 32rem;
	box-sizing: border-box;
	overflow: hidden;
}

.bg-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.entry-intro {
	padding-top: 112rem;
	text-align: center;
	color: #fff;
	// color: rgba(223, 251, 255, 0.95);

	h3 {
		margin: 0;
		font-size: 50rem;
		font-weight: 600;
		letter-spacing: 2rem;
		line-height: 1.2;
	}

	p {
		margin: 20rem 0 0;
		font-size: 20rem;
		line-height: 1;
		letter-spacing: 1.5rem;
		// color: rgba(40, 85, 110, 0.75);
	}
}

.intro-subtitle {
	margin: 18rem auto 0;
	width: fit-content;
	position: relative;
	padding: 0 64rem;
	font-size: 32rem;
	font-weight: 600;
	line-height: 1;
	color: #fff;
	// color: rgba(47, 127, 155, 0.95);

	&::before,
	&::after {
		content: "";
		position: absolute;
		top: 50%;
		width: 44rem;
		height: 2rem;
		// background: rgba(47, 127, 155, 0.95);
		color: #fff;
		transform: translateY(-50%);
	}

	&::before {
		left: 10rem;
	}

	&::after {
		right: 10rem;
	}
}

.entry-list {
	display: flex;
	flex-direction: column;
	gap: 36rem;
	width: 100%;
	margin-top: 260rem;
}

.entry-btn {
	width: 100%;
	height: 180rem;
	border: none;
	text-align: left;
	color: #fff;
	font-size: 52rem;
	line-height: 180rem;
	padding: 0 80rem;
	border-radius: 20rem;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: transparent;
}

.campus {
	background-image: url("http://pic5.40017.cn/i/ori/1MG9X8UJcLm.png");
}

.social {
	background-image: url("http://pic5.40017.cn/i/ori/1MG9WKTlVgQ.png");
}
</style>
